export default $alert => {
  const getForm = () => $alert.form
  const getOpenModal = () => $alert.openModal
  const getOpenExitModal = () => $alert.openExitModal

  return { getForm, getOpenModal, getOpenExitModal }
}
